export class UserInformation {
  public LoginName = '';
  public DisplayName = '';
  public Department = '';

  constructor(LoginName: string, DisplayName: string, Department: string) {
    this.LoginName = LoginName;
    this.DisplayName = DisplayName;
    this.Department = Department;
  }

  public get isEmpty(): boolean {
    return (!this.LoginName) && (!this.DisplayName) && (!this.Department);
  }
}
